import {motion} from 'framer-motion'
import {MidBox, TopBox, BottomBox} from '../components'
import {useEffect} from "react";


const Landing = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);


    return (
        <>
            <main className='w100'>


                <TopBox/>
                <MidBox/>
                <BottomBox/>
            </main>


        </>
    )
}
export default Landing;